module.exports = __webpack_public_path__ + "img/symphony_514_theaterred.2c58952d.jpg";